const textProps = {
  image: require("assets/img/img-1.jpg").default,
  title: "Notus Design System",
  description:
    "That’s my skill, I like to create things that last many years. I’m not really specifically talented at anything except for the ability to learn. That's it, see you at top...",
};
export default textProps;
